var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.81 209.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#666666;}.cls-3{stroke:#666666;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "230.7 148.7 78.7 148.7 44.7 32.1 270.5 32.1 230.7 148.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.7,154.1H78.7a5.46,5.46,0,0,1-5.2-3.9L39.5,33.6a5,5,0,0,1,.9-4.7,5.26,5.26,0,0,1,4.3-2.2H270.4a5.45,5.45,0,0,1,4.4,2.2,5.33,5.33,0,0,1,.7,4.9L235.8,150.4A5.37,5.37,0,0,1,230.7,154.1Zm-148-10.8H226.9l36-105.9H51.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 103,
    cy: 187.7,
    rx: 15.9,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 208.4,
    cy: 187.7,
    rx: 15.9,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103,209.4a21.71,21.71,0,1,1,21.2-21.7A21.45,21.45,0,0,1,103,209.4Zm0-32.6a10.91,10.91,0,1,0,10.5,10.9A10.72,10.72,0,0,0,103,176.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.4,209.4a21.71,21.71,0,1,1,21.2-21.7A21.45,21.45,0,0,1,208.4,209.4Zm0-32.6a10.91,10.91,0,1,0,10.5,10.9A10.72,10.72,0,0,0,208.4,176.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.7,37.5a5.25,5.25,0,0,1-5.1-3.7l-7.5-23H5.4A5.4,5.4,0,0,1,5.4,0H35.9A5.37,5.37,0,0,1,41,3.7l8.8,26.7a5.41,5.41,0,0,1-3.4,6.8A5.08,5.08,0,0,1,44.7,37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259,71.2H54.5a5.4,5.4,0,1,1,0-10.8H258.9a5.4,5.4,0,0,1,.1,10.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.12daeff3d8fc68c15903f0702cc7b1f4.svg";
export { ForwardRef as ReactComponent };